// Postcode-check widget. Real serviceable-postcode list (220 postcodes,
// Sydney-wide within 35km of 2145, founder-provided 2026-08-28 — see
// Reference Docs/postcodes-within-35km-of-2145.csv) replaces the earlier
// accept-any-4-digits placeholder. 2026-09-10: 2145 (Westmead) itself was
// missing from both the source CSV and this list — the geocoding tool that
// generated the CSV excluded the reference/origin postcode (0km from
// itself), so the actual delivery-radius center failed its own check. Added
// to both files. This is a soft, informational check only —
// it does not and cannot block checkout (Shopify's native shipping zones only
// go down to country/state granularity, no postcode-level restriction is
// possible without a third-party app or Shopify Functions/Plus). Real
// enforcement for now is the existing manual order-confirmation step
// (phase-1-launch-plan.md §3: every order confirmed within 24h before
// sourcing) — a founder catches an out-of-area order there.
var P2D_SERVICEABLE_POSTCODES = [
  '2000','2007','2008','2009','2010','2011','2015','2016','2017','2018','2019','2020',
  '2021','2022','2023','2024','2025','2026','2027','2028','2029','2030','2031','2032',
  '2033','2034','2035','2036','2037','2038','2039','2040','2041','2042','2043','2044',
  '2045','2046','2047','2048','2049','2050','2060','2061','2062','2063','2064','2065',
  '2066','2067','2068','2069','2070','2071','2072','2073','2074','2075','2076','2077',
  '2079','2080','2081','2082','2084','2085','2086','2087','2088','2089','2090','2092',
  '2093','2094','2095','2096','2097','2099','2100','2101','2102','2110','2111','2112',
  '2113','2114','2115','2116','2117','2118','2119','2120','2121','2122','2125','2126',
  '2127','2128','2130','2131','2132','2133','2134','2135','2136','2137','2138','2140',
  '2141','2142','2143','2144','2145','2146','2147','2148','2150','2151','2152','2153','2154',
  '2155','2156','2157','2158','2159','2160','2161','2162','2163','2164','2165','2166',
  '2167','2168','2170','2171','2172','2173','2174','2175','2176','2177','2178','2179',
  '2190','2191','2192','2193','2194','2195','2196','2197','2198','2199','2200','2203',
  '2204','2205','2206','2207','2208','2209','2210','2211','2212','2213','2214','2216',
  '2217','2218','2219','2220','2221','2222','2223','2224','2225','2226','2227','2228',
  '2229','2230','2231','2232','2233','2234','2555','2556','2557','2558','2559','2560',
  '2564','2565','2566','2567','2570','2745','2747','2748','2749','2750','2752','2753',
  '2754','2756','2759','2760','2761','2762','2763','2765','2766','2767','2768','2769',
  '2770','2773','2774'
];

document.querySelectorAll('[data-postcode-check]').forEach(function (root) {
  var STORAGE_KEY = 'p2d_postcode';
  var form = root.querySelector('[data-postcode-form]');
  var input = root.querySelector('[data-postcode-input]');
  var confirmedEl = root.querySelector('[data-postcode-confirmed]');
  var valueEl = root.querySelector('[data-postcode-value]');
  var changeBtn = root.querySelector('[data-postcode-change]');
  var outsideEl = root.querySelector('[data-postcode-outside]');
  var outsideChangeBtn = root.querySelector('[data-postcode-outside-change]');
  if (!form) return;

  function showConfirmed(postcode) {
    valueEl.textContent = postcode;
    form.hidden = true;
    if (outsideEl) outsideEl.hidden = true;
    confirmedEl.hidden = false;
  }

  function showOutside() {
    form.hidden = true;
    confirmedEl.hidden = true;
    if (outsideEl) outsideEl.hidden = false;
  }

  function showForm() {
    form.hidden = false;
    confirmedEl.hidden = true;
    if (outsideEl) outsideEl.hidden = true;
    input.value = '';
  }

  var saved = window.localStorage ? localStorage.getItem(STORAGE_KEY) : null;
  if (saved) showConfirmed(saved);

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var postcode = input.value.trim();
    if (!/^\d{4}$/.test(postcode)) {
      input.focus();
      return;
    }
    if (P2D_SERVICEABLE_POSTCODES.indexOf(postcode) === -1) {
      showOutside();
      return;
    }
    if (window.localStorage) localStorage.setItem(STORAGE_KEY, postcode);
    showConfirmed(postcode);
  });

  changeBtn.addEventListener('click', function () {
    if (window.localStorage) localStorage.removeItem(STORAGE_KEY);
    showForm();
  });

  if (outsideChangeBtn) {
    outsideChangeBtn.addEventListener('click', showForm);
  }
});
